import { routeConfig } from './dashboardSummary';


export default function routes($routeProvider, $locationProvider) {
  $locationProvider.hashPrefix('');
  $routeProvider.when(
    '/dashboard',
    routeConfig
  );
}

routes.$inject = ['$routeProvider', '$locationProvider'];
console.log('app.components.ssrsDashboard.routes loaded');
